import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, catchError, Observable, of, retry, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { UtilService } from './util.service';
import {
  IUpdateProBusinessBody,
  IUpdateSiteDataBody,
  IUpdateSiteUserDataBody,
  IUpdateUserDataBody,
  ISpaceNameEquipmentsResponse,
  IGroupedEquipmentsResponse,
  ScenesListResponse,
  ITimezones,
  IAccessCode,
} from '../interface-model/app-interface-model';
import { APP_MODEL_DATA } from '../model-data/app-model-data';
import { TranslateService } from '@ngx-translate/core';
import * as CryptoJS from 'crypto-js'; // For HMAC hashing
import { mergeMap } from 'rxjs/operators';
import { IUpdateSiteControllerBody } from 'src/app/interface-model/app-interface-model';
import { EquipmentDetailResponse, ControllerProfile , TechnicianType } from 'src/app/interface-model/app-interface-model';
import { Location } from '@angular/common';
import { Router } from '@angular/router';


@Injectable({
  providedIn: 'root'
})
export class MainService {

  headers = new HttpHeaders();
  domain = environment.API_URL;
  robotsDomain = environment.ROBOTS_API_URL;
 // fluidraPro = environment.PRO_API_URL;
  appSpinner = APP_MODEL_DATA.APP_SPINNER;
  siteDetails: any;
  getUserType = new BehaviorSubject(APP_MODEL_DATA.CONSUMER);
  httpClient!: HttpClient;
  proBusinessDetails: any;

  public updateRealTimeData = new BehaviorSubject<any>(null);
  public updateRealTimeData$ = this.updateRealTimeData.asObservable();

  public updateRealTimeDataForDiagnostics = new BehaviorSubject<any>(null);
  public updateRealTimeDataForDiagnostics$ = this.updateRealTimeDataForDiagnostics.asObservable();


  private equipmentDetailsSource = new BehaviorSubject<EquipmentDetailResponse | null>(null);
  equipmentDetails$ = this.equipmentDetailsSource.asObservable();

  private controllerProfileSource = new BehaviorSubject<ControllerProfile | null>(null);
  controllerProfile$ = this.controllerProfileSource.asObservable();

  public updateRealTimeDataForFeatures = new BehaviorSubject<any>(null);
  public updateRealTimeDataForFeatures$ = this.updateRealTimeDataForFeatures.asObservable();

  public realTimeForFeaturesEquipments = new BehaviorSubject<any>(null);
  public realTimeForFeaturesEquipments$ = this.realTimeForFeaturesEquipments.asObservable();

  public updateRealTimeDataForThermostats = new BehaviorSubject<any>(null);
  public updateRealTimeDataForThermostats$ = this.updateRealTimeDataForThermostats.asObservable();

  public updateRealTimeDataForLightGroups = new BehaviorSubject<any>(null);
  public updateRealTimeDataForLightGroups$ = this.updateRealTimeDataForLightGroups.asObservable();

  public telemetryDataForConnectedSystems = new BehaviorSubject<any>(null);
  public telemetryDataForConnectedSystems$ = this.telemetryDataForConnectedSystems.asObservable();

  public updateRealTimeDataForScenes = new BehaviorSubject<any>(null);
  public updateRealTimeDataForScenes$ = this.updateRealTimeDataForScenes.asObservable();
  
  public updateRealTimeDataForDCT = new BehaviorSubject<any>(null);
  public updateRealTimeDataForDCT$ = this.updateRealTimeDataForDCT.asObservable();
  updateRealTimeDataForDCTValue(data: any) {this.updateRealTimeDataForDCT.next(data);}
  
  constructor(private http: HttpClient, public uitlService: UtilService, public translate: TranslateService, private location: Location, private router: Router) {
   }

  exchangeTokenService(grantType: string, authCode?: string): Observable<any> {

    let apiUrl = '';
    let client_id = environment.CLIENT_ID;
    let refreshToken = this.uitlService.getToken('refreshToken');
    let authorizationHeader = 'Basic ' + window.btoa(environment.CLIENT_ID + ":" + environment.CLIENT_SECRET_ID);
    if (grantType === 'authorization_code') {
      apiUrl = `${environment.TOKEN_URL}?grant_type=${grantType}&code=${authCode}&redirect_uri=${environment.REDIRECT_URL}`;
    }
    else if (grantType === "refresh_token") {
      apiUrl = `${environment.TOKEN_URL}?grant_type=${grantType}&client_id=${client_id}&refresh_token=${refreshToken}`;
    }
    return this.http.post(apiUrl,
      '',
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Authorization': authorizationHeader,
          'RequestedFrom': 'CXPortal',
        }
      });
  }

  // getUserAccountDetails(user_id :any): Observable<any> {
  //   return this.http.get(`${this.domain}/users/v1/accountInfo`,{
  //     headers: {
  //       'Content-Type': 'application/json',
  //       'Authorization': this.uitlService.getToken('idToken')
  //        }
  //    }).pipe(
  //     catchError((getUserError) => {
  //       this.uitlService.hideSpinner(this.appSpinner);
  //       this.uitlService.commonErrorHandler(getUserError);
  //       return throwError(()=>getUserError);
  //     }));

  // };

  getUserAccountInfo(user_id: any): Observable<any> {
    return this.http.get(`${this.domain}/users/${user_id}/accountInfo`, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }


  getUser(userId: any): Observable<any> {
    return this.http.get(`${this.domain}/users/${userId}`, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      }
    });
  };

  //IQ-172
  getSiteDetail(siteId: any): Observable<any> {
    return this.http.get(`${this.domain}/sites/${siteId}`, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      }
    });
  };

  getEquipmentsGroup(
    siteId: number,
    groupByKey: string
  ): Observable<IGroupedEquipmentsResponse> {
    let params = { groupBy: groupByKey };
    let queryParams = new HttpParams().appendAll(params);

    return this.http.get<IGroupedEquipmentsResponse>(
      `${environment.API_URL}/sites/${siteId}/equipments`,
      {
        params: queryParams,
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
  }

  getEquipmentsBySpace(
    siteId: number,
    spaceName: string
  ): Observable<ISpaceNameEquipmentsResponse> {
    let params = { spaceName: spaceName };
    let queryParams = new HttpParams().appendAll(params);

    return this.http.get<ISpaceNameEquipmentsResponse>(
      `${environment.API_URL}/sites/${siteId}/equipments`,
      {
        params: queryParams,
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
  }

  getSessionId(): Observable<any> {
    return this.http.get(`${this.domain}/userId`, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      }
    });
  };

  getAllUsers(offset: number, sortkey: string, sort: string, pagesize: number, searchTerm?: string, roleBaseFilter?: string): Observable<any> {
    let params = { 'offset': offset, 'sortkey': sortkey, 'sort': sort, 'pagesize': pagesize };
    let queryParams = new HttpParams().appendAll(params)

    if (searchTerm) {
      queryParams = queryParams.set('searchterm', searchTerm);
    }

    if ((roleBaseFilter && (roleBaseFilter == 'consumer' || roleBaseFilter == 'support'))) {
      queryParams = queryParams.set('filterKey', 'usertype');
      queryParams = queryParams.set('filtervalue', roleBaseFilter);
    }

    return this.http.get(`${environment.API_URL}/users`, {
      params: queryParams
    });
  };

  getProBusinesses( offset?: any, limit?: any, sortBy?: any, q?: any, sortOrder?: any): Observable<any> {
    let params = {'q': q, 'offset': offset, 'sortBy':  sortBy, 'limit': limit , 'sortOrder': sortOrder};
    let queryParams = new HttpParams().appendAll(params);
    const token = this.uitlService.getToken('idToken');

    if (q) {
      queryParams = queryParams.set('q', q);
    }

    return this.http.get(`${environment.PRO_API_BASE_URL}`, {
      headers: {
                'Content-Type': 'application/json'
      },
      
      params: queryParams
    });
  };

  getPoolProContacts(role: string = 'ALL',
     q?: string,
    lastKey: string | null = null,
    limit: number = 10): Observable<any> {
    let params = new HttpParams().set('role', role);
    if (q) {
      params = params.set('q', q);
    }
    if (lastKey) {
      params = params.set('lastKey', lastKey);
    }
    if (limit) {
      params = params.set('limit', String(limit));
    }

    return this.http.get(`${environment.PRO_API_BASE_URL_V2}/admin/pro-contacts`, {
      headers: { 'Content-Type': 'application/json' },
      params
    });
  };

  getProBusinessContacts(proBusinessId: string): Observable<any> {
    return this.http.get(`${environment.PRO_API_BASE_URL_V2}/pro-businesses/${proBusinessId}/contacts`, {
      headers: { 'Content-Type': 'application/json' }
    });
  };

  addProBusiness(siteId: any, updateProBusinessData : IUpdateProBusinessBody): Observable<any> {
    return this.http.post(`${this.domain}/sites/${siteId}/business`, updateProBusinessData)
  }
 
  setProBusinessDetails(details: any) {
    this.proBusinessDetails = details;
  }

  //IQ-269 Sites List
  getAllSites(offset: number, sortkey: string, sort: string, pagesize: number, searchTerm?: string, filterValue?: any): Observable<any> {

    let params = { 'offset': offset, 'sortkey': sortkey, 'sort': sort, 'pagesize': pagesize };
    let queryParams = new HttpParams().appendAll(params);

    if (searchTerm) {
      queryParams = queryParams.set('searchterm', searchTerm);
    }

    if (filterValue) {
      queryParams = queryParams.set('filterKey', 'siteStatus');

      if (Array.isArray(filterValue)) {
        filterValue.forEach(value => {
          queryParams = queryParams.append('filterValue', value);
        });
      } else {
        queryParams = queryParams.set('filterValue', filterValue);
      }

    }

    return this.http.get(`${environment.API_URL}/sites`, {
      params: queryParams
    });

  };

  updatePersonalData(userData: any): Observable<any> {
    const userId = userData.Id;

    return this.http.post(`${this.domain}/users/${userId}/update_personal`, userData.data);
  };

  // IOTC-4160 - G suite Sign out
  gSuiteSignOut(): Observable<any> {
    let retryAttempts = 0;
    let refreshToken = this.uitlService.getToken('refreshToken');
    //authorizationHeader is the base64 conversion of <client_id>:<client_secret>
    // let authorizationHeader = 'Basic ' + window.btoa(environment.CLIENT_ID+":"+environment.CLIENT_SECRET_ID);
    let apiUrl = `${environment.SIGN_OUT_AUTH_URL}?token=${refreshToken}`;
    return this.http.post(apiUrl,
      '',
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).pipe(
        catchError((yerr) => {
          retryAttempts++
          if (yerr.status === 400 && yerr?.error?.errorcode == 'ThrottlingException' && retryAttempts <= APP_MODEL_DATA.RETRY_ATTEMPTS) {
            return throwError(() => yerr); // this will trigger retry operator
          }
          else {
            this.uitlService.hideSpinner(this.appSpinner);
            this.uitlService.signout();
            return of(yerr);
          }
        }),
        retry(APP_MODEL_DATA.RETRY_ATTEMPTS)
      )
  }

  updateUserData(updateUserData: IUpdateUserDataBody, id: string): Observable<any> {
    return this.http.patch(`${this.domain}/users/${id}`, updateUserData);
  };
  //update site service, sends the updateSiteData as payload
  // interface model is here - IUpdateSiteDataBody
  updateSiteData(updateSiteData: IUpdateSiteDataBody, siteid: string): Observable<any> {
    return this.http.put(`${this.domain}/sites/${siteid}`, updateSiteData);
  };

  // Re-send Email Verification to user
  resendEmail(userObject: any): Observable<any> {

    //need 3 of these to calculate the secret HASH using HMAC
    let clientSecret = environment.CLIENT_SECRET_ID
    let clientId = environment.CLIENT_ID
    let userName = userObject.cognitoId

    // Concatenate clientId, and userName
    let concatenatedString = `${userName}${clientId}`;
    // Calculate the HMAC using CryptoJS
    let secretHash = CryptoJS.HmacSHA256(concatenatedString, clientSecret).toString();
    // Convert the secretHash to BASE64
    let secretHashBase64 = CryptoJS.enc.Base64.stringify(CryptoJS.enc.Hex.parse(secretHash));

    let payload = {
      "ClientId": clientId,
      "Username": userName,
      'SecretHash': secretHashBase64,
    }
    return this.http.post(environment.COGNITO_IDP_URL, payload, {
      headers: {
        "X-Amz-Target": "AWSCognitoIdentityProviderService.ResendConfirmationCode",
        "Content-Type": "application/x-amz-json-1.1",
      }
    }).pipe(
      catchError((xerror) => {
        this.uitlService.hideSpinner(this.appSpinner);
        this.uitlService.commonErrorHandler(xerror);
        return throwError(() => xerror);
      }));
  };

  // Reset Password call to cognito
  resetPassword(formData: any, isProd:boolean): Observable<any> {
    //need 3 of these to calculate the secret HASH using HMAC

    //To be removed while deploying on production
    const clientSecret = isProd
      ? "u9r1uo6q3tqdnavkrqt1hinjok5o84kgnfpofe8vnfthl7eo1mk"
      : environment.CLIENT_SECRET_ID;
    const clientId = isProd
      ? "5gvrnle5vm02g76oe8fndb4k65"
      : environment.CLIENT_ID;

    let userName = formData.userName;
    // Concatenate clientId, and userName
    let concatenatedString = `${userName}${clientId}`;
    // Calculate the HMAC using CryptoJS
    let secretHash = CryptoJS.HmacSHA256(concatenatedString, clientSecret).toString();
    // Convert the secretHash to BASE64
    let secretHashBase64 = CryptoJS.enc.Base64.stringify(CryptoJS.enc.Hex.parse(secretHash));

    let payload = {
      "ClientId": clientId,
      "ConfirmationCode": formData.resetCode,
      "Password": formData.confirmPassword,
      "Username": formData.userName,
      "SecretHash": secretHashBase64
    }

    // Perform the HTTP post and use mergeMap
    return this.http.post(environment.COGNITO_IDP_URL, payload, {
      headers: {
        "X-Amz-Target": "AWSCognitoIdentityProviderService.ConfirmForgotPassword",
        "Content-Type": "application/x-amz-json-1.1"
      }
    }).pipe(
      catchError((xresetPasswordError) => {
        this.uitlService.hideSpinner(this.appSpinner);
        this.uitlService.commonErrorHandler(xresetPasswordError);
        return throwError(() => xresetPasswordError);
      }),
      mergeMap((response) => {
        // return this.confirmationEmailAPI(formData.userName); // Modify this line accordingly
        return isProd ?  this.confirmationEmailAPIProd(formData.userName) : this.confirmationEmailAPI(formData.userName);
      })
    );
  }
  // This function sends a confirmation to user's email after password was changed
  confirmationEmailAPI(userName: string): Observable<any> {
    return this.http.post(`${this.domain}/users/sendConfirmationEmail`, { userName }, { // Wrap userName in an object
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.XAPIKEY
      }
    }).pipe(
      catchError((xconfirmationEmailAPIError) => {
        this.uitlService.hideSpinner(this.appSpinner);
        this.uitlService.commonErrorHandler(xconfirmationEmailAPIError);
        return throwError(() => xconfirmationEmailAPIError);
      }));
  }

  //This is temporary function will be removed before deploying to production
  confirmationEmailAPIProd(userName: string): Observable<any> {
    return this.http.post(`https://fluidrapoolapi.zodiac-io.com/v1/users/sendConfirmationEmail`, { userName }, { // Wrap userName in an object
      headers: {
        "Content-Type": "application/json",
        "x-api-key": "pdrmR7>u2:DB&lc!F~%pU4:P:kA=t44W"
      }
    }).pipe(
    catchError((xconfirmationEmailAPIError) => {
        this.uitlService.hideSpinner(this.appSpinner);
        this.uitlService.commonErrorHandler(xconfirmationEmailAPIError);
        return throwError(() => xconfirmationEmailAPIError);
    }));
  }

  // IQ-452 | Delete User Account
  deleteUserAccount(userId: string): Observable<any> {
    return this.http.delete(`${this.domain}/users/${userId}`);
  };

  // IQ-743  IQ-794- remove site user works for both cases
  deleteSiteUser(site_id: string, userIdToDelete: any): Observable<any> {
    return this.http.delete(`${this.domain}/sites/${site_id}/userManagement?userId=${userIdToDelete}`);
  };


  editSiteNickName(site_id: string, userIdToEdit: any, newNickName: any): Observable<any> {
    return this.http.put(`${this.domain}/sites/${site_id}/editNickName`,
      {
        "userId": userIdToEdit,
        "newNickname": newNickName
      }
    );
  }

  updateSiteUserType(site_id: any, userIdToEdit: any, updatedRole: any) {
    let payload = {
      "userId": userIdToEdit,
      "role": updatedRole
    };
    return this.http.put(`${this.domain}/sites/${site_id}/userManagement`, payload);
  }

  updateSiteUsers(site_id: string, updateSiteUser: IUpdateSiteUserDataBody) {

    return this.http.put(`${this.domain}/sites/${site_id}/userManagement`, updateSiteUser);
  }

  addSiteUser(site_id: any, userIdToSave: any, userRole?: any) {
    let payload = {
      "userId": userIdToSave,
      "role": userRole ? userRole : ''
    };
    return this.http.post(`${this.domain}/sites/${site_id}/userManagement`, payload);
  }

  setSiteDetails(details: any) {
    this.siteDetails = details;
  }

  getSiteDetail1() {
    return this.siteDetails;
  }

  getUpdatedUserType(value: any) {
    this.getUserType.next(value);
  }

  /**Add Controller to Site service, sends the SiteController as payload
      interface model is here - IUpdateSiteControllerBody */
  addControllerToSite(addControllerToSiteBody: IUpdateSiteControllerBody, siteid: string): Observable<any> {
    return this.http.patch(`${this.domain}/sites/${siteid}/controllers/${addControllerToSiteBody.controllerSn}/add`, addControllerToSiteBody);
  };

  removeControllerFromSite(siteid: any, controllerId: any) {

    let payload = {
      "controllerSn": controllerId
    }

    return this.http.patch(`${this.domain}/sites/${siteid}/controllers/${controllerId}/remove`, payload);
  }

  getEquipmentList(searchTerm: string | number | boolean, offset: any) {

    let params = { 'offset': offset, 'pagesize': 10 };
    let queryParams = new HttpParams().appendAll(params)

    if (searchTerm) {
      queryParams = queryParams.set('serialNumber', searchTerm);
    }

    return this.http.get(`${environment.API_URL}/devices`, {
      params: queryParams
    });
  }

  getequipmentDetail(equipmentId: any): Observable<any> {
    return this.http.get(`${this.domain}/equipment/${equipmentId}`, {
      headers: {
        'Content-Type': 'application/json',
      }
    });
  };

  getequipmentControllerDiagnostics(controllerId: any): Observable<any> {
    return this.http.get(`${this.domain}/diagnostics/controller/${controllerId}`, {
      headers: {
        'Content-Type': 'application/json',
      }
    });
  };

  getDeviceProfile(equipmentId: any): Observable<any> {
    return this.http.get(`${environment.NGA_API_DOMAIN_DEV_INT}/devicemgmt/v1/devices/${equipmentId}/profile`, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
  };

  getActivityLog(siteId: any, offset?: any): Observable<any> {

    let params = { 'offset': offset, 'pagesize': 10 };
    let queryParams = new HttpParams().appendAll(params)

    return this.http.get(`${this.domain}/activitylog/site/${siteId}`, {
      params: queryParams,
      headers: {
        'Content-Type': 'application/json',
      }
    });
  };


  getSpaceList(siteId: any, sortkey: string, sort: string,): Observable<any> {
    let params = {
      'sortkey': sortkey,
      'sort': sort,
    };
    let queryParams = new HttpParams().appendAll(params)
    return this.http.get(`${this.domain}/sites/${siteId}/space`, {
      //params: queryParams,
      headers: {
        'Content-Type': 'application/json',
      }
    });
  }

  addSpace(siteId: any, spaceData :any): Observable<any> {
      return this.http.post(`${this.domain}/sites/${siteId}/space`, spaceData)
  }

  getSpaceById(siteId: any, spaceId:any){
    return this.http.get(`${this.domain}/sites/${siteId}/space/${spaceId}`);
  }

  updateSpaceById(siteId: any, spaceId:any, spaceData :any){
    return this.http.put(`${this.domain}/sites/${siteId}/spaces/${spaceId}`, spaceData)
  }

  removeSpace(siteId: any, spaceId:any) {
    return this.http.delete(`${this.domain}/sites/${siteId}/spaces/${spaceId}`);
  }

  getControllerEquipmentList(controllerId: any) {

    return this.http.get(`${this.domain}/controller/${controllerId}/equipment`, {
      headers: {
        'Content-Type': 'application/json',
      }
    });

  }

  getFilteredSiteList(offset: number, sortkey: string, sort: string, pagesize: number, filterValue: any) {

    let queryParameters;

    if (filterValue && filterValue.length > 0) {
      let params = {
        'offset': offset,
        'sortkey': sortkey,
        'sort': sort,
        'pagesize': pagesize,
        'filterKey': 'siteStatus',
        'filterValue': filterValue
      };

      queryParameters = new HttpParams().appendAll(params);
    } else {

      let params = {
        'offset': offset,
        'sortkey': sortkey,
        'sort': sort,
        'pagesize': pagesize,
      };

      queryParameters = new HttpParams().appendAll(params);
    }

    return this.http.get(`${this.domain}/sites`, {
      params: queryParameters,
      headers: {
        'Content-Type': 'application/json',
      }
    });

  }

  getBusinessList(siteId: any): Observable<any> {

    return this.http.get(`${this.domain}/sites/${siteId}/business`, {
      headers: {
        'Content-Type': 'application/json',
      }
    });

  };

  getProList(business_id: any): Observable<any> {

    return this.http.get(`${environment.PRO_API_BASE_URL}/${business_id}/associates`, 
      {
        headers: {
          'Content-Type': 'application/json',
        }
      }
    );

  };

  getEditedBusinessList(siteId: any, updateProBusinessData : IUpdateProBusinessBody): Observable<any> {

    return this.http.patch(`${this.domain}/sites/${siteId}/business`, updateProBusinessData,
    {
        headers: {
          'Content-Type': 'application/json',
        }
      }
    );

  };

  removeBusinessFromSite(siteId: any, payload: { businessId: string[]; }) {

    return this.http.delete(`${this.domain}/sites/${siteId}/business`,
      {
        body: payload
      }

    );
  }

  removeProContactFromSite(siteId: any, proContactId: string): Observable<any> {
    return this.http.delete(`${this.domain}/sites/${siteId}/business`, {
      body: { proContactId }
    });
  }

  setEquipmentDetails(data: EquipmentDetailResponse) {
    this.equipmentDetailsSource.next(data);
  }

  setControllerProfile(data: ControllerProfile) {
    this.controllerProfileSource.next(data);
  }

  getDetailedFeatureEquipment(featureId: any, controllerSerial: any, isThermostats:boolean = false) {

    let params = {
      'controllerSerial': controllerSerial,
      'isThermostats':isThermostats
    };
    
    let queryParameters = new HttpParams().appendAll(params);

    return this.http.get(`${this.domain}/feature/${featureId}`, {
      params: queryParameters,
      headers: {
        'Content-Type': 'application/json',
      }
    });

  }

    goBack() {
    if (window.history.length > 1) {
      this.location.back();
    } else {
      this.router.navigate(['/']);
    }
  }

  getSchedulesForSite(siteId: string | undefined, offset?: any): Observable<any> {

    let params = { 'offset': offset, 'pagesize': 10 };
    let queryParams = new HttpParams().appendAll(params)

    return this.http.get(`${this.domain}/sites/${siteId}/schedules`, {
      params: queryParams,
      headers: {
        'Content-Type': 'application/json',
      }
    });
  }

  getSiteSpaceFeatures(spaceId: string | undefined): Observable<any> {
    return this.http.get(`${this.domain}/sites/space/${spaceId}/features`, {
      headers: {
        'Content-Type': 'application/json',
      }
    });
  }

  checkEquipmentType(equipmentId: any): Observable<any> {
    return this.http.get(`${this.domain}/devices/${equipmentId}/type`, {
      headers: {
        'Content-Type': 'application/json',
      }
    });
  }

  addRobot(equipmentId: any, site_id: any, spaceId: any, signature: string): Observable<any> {

   let payload = {
      "siteid": site_id,
      "spaceid": spaceId,
      "timezone": "America/New_York",
      "signature": signature,
      "daylight_saving": true,
      "device": {
        "name": "FREEDOM LT",
        "type": "N30L"
      }
    }
 
    return this.http.post(`${this.robotsDomain}/devices/${equipmentId}/sites/add`, payload);
  }

  removeRobot(equipmentId: any, site_id: any, spaceId: any, signature: string): Observable<any> {

    let payload = {
      "siteid": site_id,
      "spaceid": spaceId,
      "signature": signature
    }

    return this.http.post(`${this.robotsDomain}/devices/${equipmentId}/sites/remove`, payload);

  }

  getSceneDetails(sceneId: any, siteId: any): Observable<any> {
    let params = {
      'siteId': siteId,
    };
    
    let queryParameters = new HttpParams().appendAll(params);

    return this.http.get(`${this.domain}/scene/${sceneId}`, {
      params: queryParameters,
      headers: {
        'Content-Type': 'application/json',
      }
    });
  
  }

  getSiteScenes(siteId: number): Observable<ScenesListResponse> {
    return this.http.get<ScenesListResponse>(`${this.domain}/sites/${siteId}/scenes`, {
      headers: {
        'Content-Type': 'application/json',
      }
    });
  }

  getWaterQualityManager(controllerSerial: string, siteUuid: string, waterQualityManagerId: string): Observable<any> {
    let params = { controllerSerial, siteUuid };
    let queryParams = new HttpParams().appendAll(params)
    return this.http.get(`${this.domain}/waterqualitymanager/${waterQualityManagerId}`, {
      params: queryParams,
      headers: {
        'Content-Type': 'application/json',
      }
    });
  }

  getTimezones(): Observable<ITimezones> {
    return this.http.get<ITimezones>(`${this.domain}/site/timezones`, {
      headers: {
        'Content-Type': 'application/json',
      }
    });
  }

  getSitePoolCustomer(proUserId: string): Observable<any> {
    return this.http.get(`${this.domain}/pros/${proUserId}/customers`, {
      headers: {
        'Content-Type': 'application/json',
        'RequestedFrom': 'CXPortal',
      }
    });
  }

  getProContacts(role?: TechnicianType, 
    q?: string,
    lastKey: string | null = null,
    limit: number = 10): Observable<any> {
    let queryParams = new HttpParams();
    if (role) {
      queryParams = queryParams.set('role', role);
    }
    if (q?.trim()) {
      queryParams = queryParams.set('q', q.trim());
    }
    if (lastKey) {
      queryParams = queryParams.set('lastKey', lastKey);
    }
    if (limit) {
      queryParams = queryParams.set('limit', String(limit));
    }
    return this.http.get(`${environment.PRO_API_BASE_URL_V2}/admin/pro-contacts`, {
      params: queryParams,
      headers: {
        'Content-Type': 'application/json',
      }
    });
  }

  getProUserDetails(proUserId: string): Observable<any> {
    let queryParams = new HttpParams();
    queryParams = queryParams.set('isPro', true);
    return this.http.get(`${environment.API_URL}/users/${proUserId}/accountInfo`, {
      params: queryParams,
      headers: {
        'Content-Type': 'application/json',
      }
    });
  }
  
  removeProUserSite(siteId: string, userId: string): Observable<any> {
    let queryParams = new HttpParams();
    if (userId) {
      queryParams = queryParams.set('userId', userId);
    }
    return this.http.delete(`${environment.API_URL}/sites/${siteId}/userManagement`, {
      params: queryParams,
      headers: {
        'Content-Type': 'application/json',
      }
    });
  }

  getAccessCodes(queryParams: { user_id_sub?: string, pro_user_id?: string }): Observable<IAccessCode> {
    let httpParams = new HttpParams();
    if (queryParams.pro_user_id) {
      httpParams = httpParams.set('pro_user_id', queryParams.pro_user_id); //For Pro user
    }
    if (queryParams.user_id_sub) {
      httpParams = httpParams.set('user_id_sub', queryParams.user_id_sub); //For Pool user
    }
    return this.http.get<IAccessCode>(`${this.domain}/users/accesscode`, {
      params: httpParams,
      headers: {
        'Content-Type': 'application/json',
      }
    });
  }
}
